import { render, staticRenderFns } from "./menumessage.vue?vue&type=template&id=74a3619c&scoped=true"
import script from "./menumessage.vue?vue&type=script&lang=js"
export * from "./menumessage.vue?vue&type=script&lang=js"
import style0 from "./menumessage.vue?vue&type=style&index=0&id=74a3619c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a3619c",
  null
  
)

export default component.exports